import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M19 2.61a.532.532 0 0 0-.96-.38L7.1 18.14c-.11.17-.13.38-.04.56.09.18.27.29.47.29h9.12c.27 0 .5-.21.53-.48L19 2.6v.01z"></path><path d="M13 29.39a.532.532 0 0 0 .96.38L24.9 13.86c.11-.17.13-.38.04-.56a.522.522 0 0 0-.47-.29h-9.12c-.27 0-.5.21-.53.48L13 29.4v-.01z"></path>';
export var LightningSVG = function LightningSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LightningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LightningSVG);